import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import { Globe } from "lucide-react"

const languages = [
  { code: 'en', name: 'English', label: 'English' },
  { code: 'es', name: 'Español', label: 'Spanish' },
  { code: 'pt', name: 'Português', label: 'Portuguese' },
  { code: 'ca', name: 'Català', label: 'Catalan' },
  { code: 'fr', name: 'Français', label: 'French' },
  { code: 'de', name: 'Deutsch', label: 'German' },
  { code: 'ar', name: 'العربية', label: 'Arabic' },
];

export function LanguagePreferences() {
  const { t, i18n } = useTranslation()

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50">
          <Globe className="mr-2 h-4 w-4" />
          <span>{t('Language preferences')}</span>
        </div>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('Language preferences')}</DialogTitle>
          <DialogDescription>
            {t('Select your preferred language')}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RadioGroup
            defaultValue={i18n.language}
            onValueChange={(value) => {
              i18n.changeLanguage(value);
            }}
          >
            {languages.map((lang) => (
              <div key={lang.code} className="flex items-center space-x-2">
                <RadioGroupItem value={lang.code} id={lang.code} />
                <Label htmlFor={lang.code}>{lang.name}</Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </DialogContent>
    </Dialog>
  )
}